<template>
  <div class="modal-mask">
    <div class="popup">
      <i v-if="isLoading" class="fas fa-spinner-third fa-spin"></i>
      <i v-else :class="iconClass"></i>
      <div class="popup-text">{{ isLoading ? 'กรุณารอสักครู่' : text }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    status: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    iconClass() {
      return this.status ? 'fal fa-check': 'fal fa-times'
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 99;
  top: 40%;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-animation: fade 3s;
  animation: fade 3s;
  -moz-animation: fade 3s;
  -o-animation: fade 3s;

  .popup {
    color: #fff;
    overflow-x: auto;
    overflow-y: auto;
    text-align: center;
    width: 157px;
    height: 130px;
    background-color: rgba(67, 67, 67, 0.85);
    border-radius: 5px;
    padding-top: 20px;
    margin: 0 auto;
    i {
      font-size: 45px;
      font-weight: 300;
    }
    .popup-text {
      text-align: center;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
    }
  }
}

@-webkit-keyframes fade {
  0% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    display: none;
  }
}

@-moz-keyframes fade {
  0% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    display: none;
  }
}

@keyframes fade {
  0% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    display: none;
  }
}

@-o-keyframes fade {
  0% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    display: none;
  }
}
</style>